const SHARE_CACHE = 'swarm-share-v1';

export interface SharedItem {
  name: string;
  blob: Blob;
  url: string;
}

export interface Shared {
  title: string;
  text: string;
  url: string;
  photos: SharedItem[];
}

/** What the service worker kept from the Share Target (`/teilen`); null if nothing. */
export async function readShared(): Promise<Shared | null> {
  if (typeof caches === 'undefined') return null;
  const cache = await caches.open(SHARE_CACHE);
  const metaResponse = await cache.match('/share/meta');
  if (!metaResponse) return null;
  const meta = (await metaResponse.json()) as {
    title: string;
    text: string;
    url: string;
    files: number;
  };
  const photos: SharedItem[] = [];
  for (let i = 0; i < meta.files; i += 1) {
    const response = await cache.match(`/share/file/${i}`);
    if (!response) continue;
    const blob = await response.blob();
    photos.push({
      name: decodeURIComponent(response.headers.get('x-swarm-name') ?? `foto-${i + 1}`),
      blob,
      url: URL.createObjectURL(blob),
    });
  }
  return { title: meta.title, text: meta.text, url: meta.url, photos };
}

export async function clearShared(): Promise<void> {
  if (typeof caches !== 'undefined') await caches.delete(SHARE_CACHE);
}

/** One line for the note: shared text and title without a link that only repeats the text. */
export function noteText(shared: Pick<Shared, 'title' | 'text' | 'url'>, fallback: string): string {
  const parts = [shared.title, shared.text, shared.url]
    .map((p) => p.trim())
    .filter((p, i, all) => p && all.indexOf(p) === i);
  return parts.join('\n') || fallback;
}
